import React from "react";
import { Span } from "../styled_components/divs";
import BatteryIcon from "./BatteryIcon";
import t from "../../../helpers/t";
import ExtraIcon from "./ExtraIcon";

const Akkus = (props) => {
  let style = { paddingTop: "7px" };
  if (typeof props.style !== "undefined") {
    style = props.style;
  }
  let extraStyle = {};
  Object.assign(extraStyle, style);

  if (props.countOfIcons < 4) {
  } else {
    extraStyle.paddingTop = "10px";
  }
  let count = 0;
  let bigIconsCount = 0;
  if (props.resource.lock_battery_value !== null) {
    count++;
    bigIconsCount++;
  }
  if (props.resource.battery_value !== null) {
    count++;
    bigIconsCount++;
  }
  if (props.resource.ilockit_device_id !== null && props.resource.online) {
    count += 2;
  }
  if (count === 4) {
    extraStyle.paddingTop = "10px";
  }
  if (bigIconsCount < 2 && count > 2) {
  }
  return (
    <>
      {props.resource.lock_battery_value !== null && ++count && (
        <Span style={style}>
          {props.lockPending === null ? (
            <BatteryIcon
              Value={props.resource.lock_battery_value}
              Name="lock"
              locked={props.locked}
              Resource={props.resource}
              key={"icon_resource_lock_battery_" + props.resource.id}
              showPercent={props.showPercent}
              EventHandler={props.switchLock}
              small={props.small}
            />
          ) : (
            <>
              {" "}
              <span>
                <img
                  alt="RollingLoader"
                  className="rollingLoader colorize-black"
                  src={"assets/img/rolling_loader.svg"}
                />{" "}
              </span>
            </>
          )}
        </Span>
      )}
      {props.resource.battery_value !== null && ++count && (
        <Span style={style}>
          <BatteryIcon
            Value={props.resource.battery_value}
            Name="bike"
            locked={true}
            Resource={props.resource}
            key={"icon_resource_battery_" + props.resource.id}
            showPercent={props.showPercent}
            EventHandler={props.switchLock}
          />
        </Span>
      )}
      {props.resource.ilockit_device_id !== null && ++count && props.resource.online && (
        <>
          <Span
            title={t("signalSound", null, "capital")}
            style={
              count > 2 && props.countOfIcons === 4
                ? extraStyle
                : bigIconsCount < 2 && count > 2
                  ? { ...style, paddingLeft: "20px" }
                  : style
            }
          >
            {props.lockSignalPending === null ? (
              <ExtraIcon
                Name="signalSound"
                Resource={props.resource}
                key={"icon_resource_signal_" + props.resource.id}
                EventHandler={props.sendSignalSound}
              />
            ) : (
              <>
                {" "}
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader colorize-black"
                    src={"assets/img/rolling_loader.svg"}
                  />{" "}
                </span>
              </>
            )}
          </Span>
        </>
      )}
      {props.resource.ilockit_device_id !== null && ++count && props.resource.online && (
        <>
          <Span
            title={t("theft", null, "capital")}
            style={count > 2 && props.countOfIcons === 4 ? extraStyle : style}
          >
            {props.lockTheftPending === null ? (
              <ExtraIcon
                Name="theft"
                key={"icon_resource_theft_" + props.resource.id}
                Resource={props.resource}
                EventHandler={props.toggleTheft}
              />
            ) : (
              <>
                {" "}
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader colorize-black"
                    src={"assets/img/rolling_loader.svg"}
                  />{" "}
                </span>
              </>
            )}
          </Span>
        </>
      )}
    </>
  );
};

export default Akkus;
